import { Dispatch } from 'react';
import { Action, Reducer } from 'redux';
import { EmptyRequestState } from '../../models/RequestState';
import InstanceClient from '../../services/InstanceClient';
import StatusCode from '../../util/StatusCode';
import { CoreOneRosterConfiguration } from "../../models/CoreOneRosterConfigurationModels";


enum OneRosterConfigurationType {
    GENERATE_CLIENT_CREDETIALS = 'GENERATE_CLIENT_CREDETIALS'
}

export interface OneRosterConfigurationState {
    oneRosterClientCredentials: EmptyRequestState
}
interface OneRosterConfiguration_ClientCredentials extends Action<OneRosterConfigurationType> {
    type: OneRosterConfigurationType.GENERATE_CLIENT_CREDETIALS,
    oneRosterClientCredentials: EmptyRequestState
}

type OneRosterConfigurationAction = OneRosterConfiguration_ClientCredentials;

export const GenerateOneRosterClientCredentials = (id: string) => (dispatch: Dispatch<OneRosterConfiguration_ClientCredentials>) => {
    dispatch({
        type: OneRosterConfigurationType.GENERATE_CLIENT_CREDETIALS,
        oneRosterClientCredentials: { code: StatusCode.PENDING }
    });

    return InstanceClient.post<CoreOneRosterConfiguration, CoreOneRosterConfiguration>(`/api/core/oneRosterConfiguration/${id}/generateClientCredential`)
        .then(res => {
            dispatch({
                type: OneRosterConfigurationType.GENERATE_CLIENT_CREDETIALS,
                oneRosterClientCredentials: { code: StatusCode.COMPLETE }
            });
            return res.data as CoreOneRosterConfiguration;
        })
        .catch(error => {
            dispatch({
                type: OneRosterConfigurationType.GENERATE_CLIENT_CREDETIALS,
                oneRosterClientCredentials: { code: StatusCode.ERROR, error }
            })
        })
        
}

export const ClearGenerateOneRosterClientCredentials = () => (dispatch: Dispatch<OneRosterConfiguration_ClientCredentials>) => {
    dispatch({
        type: OneRosterConfigurationType.GENERATE_CLIENT_CREDETIALS,
        oneRosterClientCredentials: { code: StatusCode.NONE }
    });
}

const initialState: OneRosterConfigurationState = {
    oneRosterClientCredentials: { code: StatusCode.NONE }
}

export const reducer: Reducer<OneRosterConfigurationState, OneRosterConfigurationAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case OneRosterConfigurationType.GENERATE_CLIENT_CREDETIALS:
            return {
                ...state,
                oneRosterClientCredentials: action.oneRosterClientCredentials
            }
        default:
            return state;
    }
}